import React, { Component } from 'react';
import { Group } from 'src/mundial/requests/interfaces';
import ApiMundial from '../../requests/api';
import TeamCard from '../TeamCard';
import './_styles.scss';
import Utils from 'src/utils/Utils';

interface IState {
  groups: Group[];
}

export default class Groups extends Component<{}, IState> {
    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {
            groups: []
        }
    }

    async componentDidMount() {
        const groups = await ApiMundial.getTeamsByGroup();
        this.setState({groups});
    }

    componentDidUpdate() {
        Utils.setInitialFocus(".ribbon-categories.mundial a:nth-child(3)");
    }

    render() {
        return (
            <div className="container-groups">
                {this.state.groups.map((group, rowIndex) => 
                    <div className="ribbon-row" key={group.groupId}>
                        <p className="group-name">{group.groupName}</p>
                        <div className="group-row">
                            {
                                group.teams.map((team, colIndex) => 
                                    <TeamCard
                                        key={team.id}
                                        withRibbonTitle 
                                        team={team} 
                                        upFocus={rowIndex > 0 ? `#row-${rowIndex-1}-col-${colIndex}` : undefined}
                                        leftFocus={colIndex === 0 ? '': undefined} 
                                        rightFocus={colIndex === 3 ? '': undefined} 
                                        id={`row-${rowIndex}-col-${colIndex}`}
                                        row={rowIndex}
                                        parentComponent={"groups"}
                                        />)
                            }
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/mundial/Home/Groups/index.tsx